<template>
  <b-tooltip label="Asignar Paciente" type="is-dark">
    <b-tooltip label="Cama bloqueada"
            position="is-top"
            :active="bed.state == 'BLOQUEADA' && bed.patient_id == null">
      <b-button :disabled="bed.state == 'BLOQUEADA' && bed.patient_id == null" type="is-primary" size="is-small" @click="openModal" icon-left="hand-pointer"></b-button>
    </b-tooltip>
  </b-tooltip>
</template>
<script>
  import ModalAssignPatient from "./ModalAssignPatient";
  export default {
    props: ["bed"],
    methods: {
      openModal() {
        this.$buefy.modal.open({
          parent: this,
          component: ModalAssignPatient,
          props: {
            bed: this.bed,
          },
          hasModalCard: true,
          trapFocus: true,
        });
      },
    },
  };
</script>